// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- Building DS */
/* stylelint-disable property-disallowed-list -- Building DS */

.InputView-module__Container__frvDx {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--ds-s);
    align-items: flex-start;
    width: 100%;
}

.InputView-module__LabelContainer__zf7uX {
    display: flex;
    gap: var(--ds-xs);
    align-items: center;
    max-width: 100%;
}

.InputView-module__TooltipIcon__dJ01c {
    color: var(--ds-input-label-tooltip-icon-color);
}

.InputView-module__LabelDisabled__zhuht {
    color: var(--ds-input-disabled-label-color);
}

.InputView-module__DescriptionDisabled__QJ1ZP {
    color: var(--ds-input-disabled-description-color);
}

.InputView-module__InnerWrapper__sq55y {
    display: flex;
    flex-grow: 1;
    align-items: center;
    align-self: stretch;
    box-sizing: content-box;
    padding: var(--ds-xs) 0;
    background: var(--ds-input-field-bg-color);
    border-radius: var(--ds-border-radius-sm);
    box-shadow: 0 0 0 var(--ds-border-width) var(--ds-input-field-border-color)
        inset;
}

.InputView-module__InnerWrapperWithEndSlot__mkBV3 {
    gap: var(--ds-s);
    padding-right: var(--ds-m);
}

.InputView-module__Disabled__sJ87O {
    background: var(--ds-input-field-disabled-bg-color);
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-disabled-border-color) inset;
}

.InputView-module__InnerWrapper__sq55y:hover {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-hover-border-color) inset;
}

.InputView-module__Disabled__sJ87O:hover {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-disabled-border-color) inset;
}

.InputView-module__Errored__sh03e {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-error-border-color) inset;
}

.InputView-module__Errored__sh03e:hover {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-error-border-color) inset;
}

.InputView-module__Focused__FDxvq {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-focused-border-color) inset;
}

.InputView-module__Focused__FDxvq:hover {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-focused-border-color) inset;
}

.InputView-module__Input__rCTIW {
    all: unset;
    width: 100%;
    padding: var(--ds-s) 0 var(--ds-s) var(--ds-m);
    color: var(--ds-input-field-text-color);
    font-size: var(--ds-font-size-m);
    line-height: var(--ds-line-height-big);
}
/* TODO: https://lucidlink.atlassian.net/browse/LUCID-27887 */
/* stylelint-disable-next-line plugin/no-unsupported-browser-features -- Unexpected browser feature "css-autofill" is not supported by Firefox 147-148 */
.InputView-module__Input__rCTIW:autofill,
.InputView-module__Input__rCTIW:autofill:focus {
    transition:
        background-color 600000s 0s,
        color 600000s 0s;
}

.InputView-module__InputWithoutIcon__EdhiF {
    padding-right: var(--ds-m);
}

.InputView-module__Input__rCTIW:read-only {
    color: var(--ds-input-field-readonly-text-color);
}

.InputView-module__Input__rCTIW:disabled {
    color: var(--ds-input-field-disabled-text-color);
}

.InputView-module__Input__rCTIW:disabled::placeholder {
    color: var(--ds-input-field-disabled-placeholder-color);
}

.InputView-module__Input__rCTIW::placeholder {
    color: var(--ds-input-field-placeholder-color);
    font-size: var(--ds-font-size-m);
}
/* stylelint-enable property-disallowed-list -- Building DS */
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `InputView-module__Container__frvDx`,
	"LabelContainer": `InputView-module__LabelContainer__zf7uX`,
	"TooltipIcon": `InputView-module__TooltipIcon__dJ01c`,
	"LabelDisabled": `InputView-module__LabelDisabled__zhuht`,
	"DescriptionDisabled": `InputView-module__DescriptionDisabled__QJ1ZP`,
	"InnerWrapper": `InputView-module__InnerWrapper__sq55y`,
	"InnerWrapperWithEndSlot": `InputView-module__InnerWrapperWithEndSlot__mkBV3`,
	"Disabled": `InputView-module__Disabled__sJ87O`,
	"Errored": `InputView-module__Errored__sh03e`,
	"Focused": `InputView-module__Focused__FDxvq`,
	"Input": `InputView-module__Input__rCTIW`,
	"InputWithoutIcon": `InputView-module__InputWithoutIcon__EdhiF`
};
export default ___CSS_LOADER_EXPORT___;
